import { collection, documentId, getDocs, query, where } from 'firebase/firestore';
import { Client } from '@eql-ai/typescript-types';
import { firestoreInstance } from 'config/ApiService';
import { CLIENTS } from 'core/utils/collectionNames';
import PhioengageService, { ServiceResponse } from 'services/PhioengageService';

export async function getAccessibleClients(params: {
    region: string;
    userId: string;
    orgId: string;
}): Promise<Client[]> {
    const resp = await new PhioengageService<
        { region: string; userId: string; orgId: string },
        ServiceResponse
    >().invoke(params, 'phioaccess-permissions-getaccessibleclients');

    if (!resp?.data.success) {
        return [];
    }
    const allowedIds = resp.data?.data?.allowedClientIds || resp.data?.data?.allowedClients || [];
    if (allowedIds.length === 0) {
        return [];
    }
    const chunkSize = 30;
    const chunks: string[][] = [];
    for (let i = 0; i < allowedIds.length; i += chunkSize) {
        chunks.push(allowedIds.slice(i, i + chunkSize));
    }
    const snapshots = await Promise.all(
        chunks.map((chunk) =>
            getDocs(
                query(collection(firestoreInstance(), CLIENTS), where(documentId(), 'in', chunk))
            )
        )
    );

    const byId = new Map<string, Client>();
    snapshots.forEach((snapshot) => {
        snapshot.forEach((doc) => {
            byId.set(doc.id, { id: doc.id, ...doc.data() } as Client);
        });
    });

    return Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name));
}
